// extracted by mini-css-extract-plugin
module.exports = {"topicTop":"topicTop-1Uaxt-4R","title":"title-1mxdEfdb"};